import axios from "axios"
import baseUrl from "./base"

const akunApi = {
  getAllAkun: async (data, token) => {
    return await axios.get(`${baseUrl}/api/akun/get`,
      { params: data, headers: { Authorization: `Bearer ${token}` } }
    )
  },
  getAkunByDesa: async (data, token) => {
    return await axios.get(`${baseUrl}/api/akun/getByDesa`,
      { params: data, headers: { Authorization: `Bearer ${token}` } }
    )
  },
  getAkunByKecamatan: async (data, token) => {
    return await axios.get(`${baseUrl}/api/akun/getByKecamatan`,
      { params: data, headers: { Authorization: `Bearer ${token}` } }
    )
  },
  updateAkun: async (id, data, token) => {
    return await axios.post(`${baseUrl}/api/akun/${id}/update`, data,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  resetPassword: async (id, token) => {
    return await axios.get(`${baseUrl}/api/akun/${id}/resetPassword`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  disableAkun: async (id, token) => {
    return await axios.get(`${baseUrl}/api/akun/${id}/disable`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  enableAkun: async (id, token) => {
    return await axios.get(`${baseUrl}/api/akun/${id}/enable`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  hapusAkun: async (id, token) => {
    return await axios.delete(`${baseUrl}/api/akun/${id}/destroy`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  generateOtp: async (id, token) => {
    return await axios.get(`${baseUrl}/api/akun/${id}/generateOtp`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
}

export default akunApi